// extracted by mini-css-extract-plugin
export var editButton = "_n1-0";